module.exports = __webpack_public_path__ + "img/lead_down_arrow.aa5cc598.svg";